<template>
    <a-slider
        v-model="progress"
        @change="progressChange"
        :tipFormatter="formatter"
    />
</template>

<script>
 import Vue from 'vue';
 import EventBus from "../event/event-bus.js"
 import Slider from "ant-design-vue/lib/slider";

 import { formatSecond } from "../util/time.js"

 Vue.component(Slider.name, Slider);

 export default {
     name: 'ProgressBar',
     data() {
         return {
             progress: 0,
             duration: 0
         }
     },
     props: {
     },
     components: {
     },
     created() {
         console.log("Create ProgressBar")
     },
     mounted() {
         console.log("Mount ProgressBar")

         EventBus.$on("playerProgress", (duration, current) => {
             this.duration = duration
             this.progress = current * 100 / duration
         })
     },
     beforeDestroy() {
         EventBus.$off("playerProgress");
     },
     methods: {
         formatter: function(value) {
             return formatSecond(value * this.duration / 100.0)
         },
         progressChange: function(value) {
             EventBus.$emit("playerSeek", value)
         }
     }
 }
</script>

<style scoped>
 .ant-slider {
     flex: 1;
 }
</style>
